import { render, staticRenderFns } from "./FacetPanel.vue?vue&type=template&id=aaf2332c&scoped=true&"
import script from "./FacetPanel.vue?vue&type=script&lang=ts&"
export * from "./FacetPanel.vue?vue&type=script&lang=ts&"
import style0 from "./FacetPanel.vue?vue&type=style&index=0&id=aaf2332c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf2332c",
  null
  
)

export default component.exports